import React from 'react';
import axios from '../axios';
import ModalContentBase from '../redux/components/modal/modal_content_base';

const youtubePrefix01 = 'https://www.youtube.com/watch?v=';
const youtubePrefix02 = 'https://youtu.be/';

const SectionYoutube = ({ eventId, youtubeContents, setContents }) => {
  const [selectedId, setSelectedId] = React.useState(0);
  const modalRef = React.useRef(null);

  const deleteContent = React.useCallback(() => {
    axios
      .post('/api/event_edit/delete_content', {
        id: selectedId,
        event_id: eventId,
      })
      .then((response) => {
        setContents((prev) =>
          prev.filter((content) => content.id !== selectedId)
        );
        modalRef.current.closeModal();
      });
  }, [selectedId, youtubeContents]);

  const onSubmit = React.useCallback((body) => {
    axios
      .post(`/api/event_edit/create_content`, {
        body: body,
        content_type: 4,
        event_id: eventId,
      })
      .then((response) => {
        setContents((prev) => [...prev, response.data]);
      });
  }, []);

  return (
    <section id="youtube">
      <div className="container col-md-8 col-lg-6 mb-0 pb-0">
        <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-5 d-inline-block">
          YouTube
        </p>
        <p className="text-gray text-fz-small mt-0 mb-1 pb-0">複数登録可</p>
      </div>
      <div>
        <div className="bg-gray mt-0 pt-0">
          <div id="contents_sort" className="single-body single-body-margin">
            {youtubeContents.map((content) => {
              return (
                <EnbedContent
                  key={`contentItem_${content.id}`}
                  content={content}
                  openModal={() => {
                    setSelectedId(content.id);
                    modalRef.current.openModal();
                  }}
                />
              );
            })}
          </div>
          <InputContent onSubmit={onSubmit} />
          <div>
            <ModalContentBase
              ref={modalRef}
              previewContent={<div />}
              modalContent={
                <ActModalContent
                  deleteContent={deleteContent}
                  closeModal={() => modalRef.current.closeModal()}
                />
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const EnbedContent = ({ content, openModal }) => {
  return (
    <div className="bg-white" key={`contentItem_${content.id}`} id={content.id}>
      <div className=" container col-md-8 col-lg-6 pl-2 pr-2">
        <div className="d-flex justify-content-between">
          <div className="col-10 pt-3 pr-0">
            <div className="video">
              <iframe
                src={`https://www.youtube.com/embed/${content.body}`}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
          <p className="col-2 p-2 pl-5 mb-0 text-black-20 d-flex align-items-center">
            <img
              src="/assets2019/img/icon_reader.svg"
              alt=""
              onClick={openModal}
            />
          </p>
        </div>
      </div>
    </div>
  );
};

const InputContent = ({ onSubmit }) => {
  const [body, setBody] = React.useState('');
  const [bodyWithPrefix, setBodyWithPrefix] = React.useState('');

  const onClickComplete = React.useCallback(() => {
    onSubmit(body);
    setBody('');
    setBodyWithPrefix('');
  }, [body]);

  const onChange = React.useCallback((e) => {
    let bodyWithPrefix = e.target.value;
    let body = '';

    // prefixを除去
    if (!bodyWithPrefix.indexOf(youtubePrefix01)) {
      body = bodyWithPrefix.replace(youtubePrefix01, '');
    } else if (!bodyWithPrefix.trim().indexOf(youtubePrefix02)) {
      body = bodyWithPrefix.replace(youtubePrefix02, '');
    }

    // 末尾の空白・スラッシュ削除
    body = body.trim().replace(/\/$/, '');

    setBody(body);
    setBodyWithPrefix(bodyWithPrefix);
  }, []);

  return (
    <div style={{ paddingBottom: 0, paddingTop: 16 }} className="bg-gray">
      <div className="shadow-sm mb-0 bg-white">
        <div className="container col-md-8 col-lg-6 p-3_5">
          <div className="m-0 d-flex">
            <input
              id="body"
              className="p-0 w-100 textarea--eventreport"
              value={bodyWithPrefix}
              onChange={onChange}
              placeholder={`${youtubePrefix01}ABCdEf`}
            />
          </div>
          <button
            ref={(node) => {
              if (node) {
                node.style.setProperty('margin-right', '0', 'important');
              }
            }}
            className="a-button a-button__top a-button--orange mt-2"
            disabled={body == ''}
            onClick={onClickComplete}
          >
            完了
          </button>
        </div>
      </div>
    </div>
  );
};

const ActModalContent = ({ deleteContent, closeModal }) => {
  return (
    <div className="card bg-gray pt-3">
      <button
        type="button"
        className="close close__modal position-absolute position--modalclose"
        aria-label="Close"
        onClick={closeModal}
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h6 className="text-fw-bold text-center mb-3_5">
        アクションを選択してください
      </h6>
      <div className="card bg-white h-100">
        <ul className="nav flex-column">
          <li
            className="nav-item p-3 border-bottom"
            key={2}
            onClick={deleteContent}
          >
            <label className="d-flex justify-content-between align-items-center mb-0 position-relative">
              <span className="p-0 line-height-2 pl-3 mb-0">削除する</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
          <li
            className="nav-item p-3 border-bottom"
            key={3}
            onClick={closeModal}
          >
            <label className="d-flex justify-content-between align-items-center mb-0 position-relative">
              <span className="p-0 line-height-2 pl-3 mb-0">キャンセル</span>
              <span className="checkbox__lg checkbox__noborder" />
            </label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SectionYoutube;
